<template>
  <v-form data-external-clients>
    <div class="pr-2">
      <div class="pb-3">
        <v-layout row wrap align-center>
          <v-flex class="subheading">{{ lang.circle_ms_client_name }}</v-flex>
          <v-flex class="text-xs-right">
            <v-btn-toggle v-model="isEnabledCircleMs" mandatory>
              <v-btn
                flat
                :value="true"
                :disabled="!isClientEnabledCircleMs"
                :style="{ 'text-transform': 'none' }"
              >
                <v-icon
                  small
                  :class="{
                    [$style.checkIcon]: true,
                    [$style.checkIcon__active]: isEnabledCircleMs,
                    'mr-1': true
                  }"
                  >fa fa-check</v-icon
                >
                <span>{{ lang.circle_ms_enabled }}</span>
              </v-btn>
              <v-btn
                flat
                :value="false"
                :disabled="!isClientEnabledCircleMs"
                :style="{ 'text-transform': 'none' }"
              >
                <v-icon
                  small
                  :class="{
                    [$style.checkIcon]: true,
                    [$style.checkIcon__active]: !isEnabledCircleMs,
                    'mr-1': true
                  }"
                  >fa fa-check</v-icon
                >
                <span>{{ lang.circle_ms_disabled }}</span>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
        <vc-share-text-contains-link
          :replace="{
            ':name': {
              text: lang.circle_ms_description_name,
              href: circleMsUrl,
              target: '_blank'
            },
            ':help_link': {
              text: lang.circle_ms_description_help_link,
              href: circleMsMyPortalUrl,
              target: '_blank'
            }
          }"
        >
          <div>
            {{ lang.circle_ms_description }}
            <span v-if="locale != 'ja-jp'"> {{ lang.japanese_only }} </span>
          </div>
          <div>{{ lang.circle_ms_description_notice }}</div>
          <div v-if="!isClientEnabledCircleMs" class="mt-2">
            {{ lang.circle_ms_description_help }}
          </div>
        </vc-share-text-contains-link>
        <div class="text-xs-right">
          <v-btn
            color="info"
            @click="onSaveChangesCircleMs"
            :class="[$style.btnTextStyle, 'mr-0']"
            :loading="isLoading"
            :disabled="!isClientEnabledCircleMs"
            >{{ lang.save }}</v-btn
          >
        </div>
      </div>
      <v-divider></v-divider>
      <div class="pt-3 pb-2">
        <v-layout row wrap align-center>
          <v-flex class="subheading">{{ lang.navio_client_name }}</v-flex>
          <v-flex class="text-xs-right">
            <vc-share-link-btn :href="navioUrl" target="_blank" class="mr-0">{{
              lang.navio_listing_button
            }}</vc-share-link-btn>
          </v-flex>
        </v-layout>
        <vc-share-text-contains-link
          :replace="{
            ':name': {
              text: lang.navio_description_name,
              href: navioUrl,
              target: '_blank'
            },
            ':help_link': {
              text: lang.navio_description_help_link,
              href: navioHelpUrl,
              target: '_blank'
            }
          }"
        >
          {{ lang.navio_description }}
          <span v-if="locale != 'ja-jp'"> {{ lang.japanese_only }} </span>
          <br />
          {{ lang.navio_description_help }}
        </vc-share-text-contains-link>
      </div>
    </div>
  </v-form>
</template>

<script>
import ice from "../../../lib/ice";
import qs from "qs";

export default {
  name: "vc-share-my-contents-external-clients",
  props: {
    locale: {
      type: String,
      default: ""
    },
    lang: {
      Type: Object,
      default: () => {
        return {};
      }
    },
    validationLang: {
      type: Object,
      default: () => {
        return {
          required: "",
          max: {
            string: ""
          }
        };
      }
    },
    contentsId: { type: Number, default: 0 },
    isClientEnabledCircleMs: { type: Boolean, default: false },
    clientIdCircleMs: { type: String, default: "" },
    initialIsEnabledCircleMs: { type: Boolean, default: false },
    circleMsUrl: { type: String, default: "" },
    circleMsMyPortalUrl: { type: String, default: "" },
    navioUrl: { type: String, default: "" },
    navioHelpUrl: { type: String, default: "" },
    saveExternalClients: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      isEnabledCircleMs: this.initialIsEnabledCircleMs,
      isLoading: false
    };
  },
  mounted: function() {
    const params = qs.parse(window.location.search.replace("?", ""));
    if (params["scrollto"] === "external-clients") {
      this.$vuetify.goTo("[data-external-clients]", { offset: -120 });
    }
  },
  methods: {
    onSaveChangesCircleMs: function() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this.isLoading = true;

        let requestData = [];

        if (this.isClientEnabledCircleMs) {
          requestData.push({
            contentsId: this.contentsId,
            clientId: this.clientIdCircleMs,
            isEnabled: this.isEnabledCircleMs
          });
        }

        this.saveExternalClients(requestData).then(status => {
          if (status === 0) {
            location.reload();
          } else {
            this.isLoading = false;
          }
        });
      });
    },
    onClick(event) {
      ice.onClickLink(event);
    }
  }
};
</script>

<style module>
.checkIcon {
  visibility: hidden;
}

.checkIcon__active {
  visibility: visible;
}

.btnTextStyle {
  text-transform: none !important;
}
</style>
